import React from 'react';
import { connect } from 'react-redux';
import { toArray, isEmpty } from 'lodash';

import {
    FormComponent,
    CheckboxInputFieldComponent,
    LegendFieldComponent
} from '../../../../components/form';
import {
    sendInterestsUpdateRequestAndFetchUserCriteria,
    fetchUserCriteriaIfNeeded,
    reset
} from '../../../../services/account/myinterests/actions';
import { CATEGORIES } from '../../../../services/criteria/constants';
import { SuccessInfoComponent } from '../../../form/SuccessInfoComponent';
import { withLoadingCondition } from '../../../loading/withLoadingCondition';
import { fetchCriteriaIfNeeded } from '../../../../services/criteria/actions';
import { getI18nByApp } from '../../../../services/i18n/selector';

const FORM_NAME = 'interests-form';

class InterestsFormComponent extends React.Component {
    componentDidMount() {
        this.props.fetchCriteriaIfNeeded(CATEGORIES);
        this.props.fetchUserCriteriaIfNeeded(CATEGORIES);
    }

    submit = formData => {
        const { sendInterestsUpdateRequestAndFetchUserCriteria, reset } = this.props;
        sendInterestsUpdateRequestAndFetchUserCriteria(formData, CATEGORIES, () => {
            setTimeout(() => {
                reset();
            }, 3000);
        });
    };

    populate() {
        return this.props.criteria.map((c, i) => ({ label: c.label, value: c.id }));
    }

    renderForm = () => {
        const {
            i18n,
            isAuthed,
            initialValues,
            errorMessage,
            errorSubmit,
            updatingUserCriteria,
            successSubmit
        } = this.props;

        return (
            <FormComponent
                form={FORM_NAME}
                initialValues={isAuthed ? initialValues : {}}
                onSubmit={this.submit}
                requestSubmit={updatingUserCriteria}
                errorSubmit={errorSubmit}
                submitText={getI18nByApp(i18n, 'page.ACCOUNT.INTERESTS.BUTTON_VALIDATE')}>
                <CheckboxInputFieldComponent name="interests" options={this.populate()} />
                {errorMessage && (
                    <LegendFieldComponent classNameInputContainer="color-err message full">
                        {errorMessage}
                    </LegendFieldComponent>
                )}
                {successSubmit && (
                    <SuccessInfoComponent>
                        <p>{getI18nByApp(i18n, 'page.ACCOUNT.INTERESTS.SUBMIT_SUCCEEDED')}</p>
                    </SuccessInfoComponent>
                )}
            </FormComponent>
        );
    };

    render() {
        const { fetchingUserCriteria } = this.props;
        return withLoadingCondition(fetchingUserCriteria, this.renderForm);
    }
}

function mapStateToProps(state) {
    const userCriteria = toArray(state.account.myinterests.usercriteria[CATEGORIES]);

    return {
        i18n: state.i18n,
        isAuthed: !isEmpty(state.authentication.token),
        initialValues: {
            interests: userCriteria
        },
        errorMessage: state.account.myinterests.error,
        errorSubmit: !isEmpty(state.account.myinterests.errorMessage),
        criteria: toArray(state.criteria.criteria[CATEGORIES]),
        successSubmit: state.account.myinterests.successInterestsUpdateRequestSubmit,
        fetchingUserCriteria: state.account.myinterests.fetching,
        updatingUserCriteria: state.account.myinterests.updating
    };
}

const mapDispatchtoProps = {
    fetchCriteriaIfNeeded,
    fetchUserCriteriaIfNeeded,
    sendInterestsUpdateRequestAndFetchUserCriteria,
    reset
};

export default connect(mapStateToProps, mapDispatchtoProps)(InterestsFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/myinterests/InterestsFormComponent.js